<template>
  <div class="paypal-pay-later-info">
    <h4 class="paypal-pay-later-info__title u-typography-helvetica u-text u-text--m">
      {{ $t(payLaterOptionInfo.title) }}
    </h4>

    <i18n
      :path="payLaterOptionInfo.mainDescription"
      tag="p"
      class="paypal-pay-later-info__description-main u-typography-helvetica u-text u-text--xs"
    >
      <span v-if="!isCountryGreatBritain">
        {{ paymentAmount }}
      </span>
      <span>
        {{ paymentPart }}
      </span>
    </i18n>

    <i18n
      :path="payLaterOptionInfo.secondaryDescription"
      tag="p"
      class="paypal-pay-later-info__description-secondary description-secondary u-typography-helvetica u-text u-text--xs"
    >
      <span class="paypal-pay-later-info__description-secondary--bold-part">
        {{ $t('paypal.modalPayLater.label.paypal') }}
      </span>
      <span class="paypal-pay-later-info__description-secondary--bold-part">
        {{ $t(payLaterOptionInfo.paypalPayLaterLabel) }}
      </span>
    </i18n>

    <div v-if="isCountryAustralia" class="paypal-pay-later-info__details-info details-info">
      <h5 class="details-info__title u-typography-helvetica u-text u-text--s">
        {{ $t('paypal.modalPayLater.aboutPayIn4.title') }}
      </h5>
      <ul class="details-info__list u-typography-helvetica u-text u-text--xs">
        <li>{{ $t('paypal.modalPayLater.aboutPayIn4.offerAavailability') }}</li>
        <li>{{ $t('paypal.modalPayLater.aboutPayIn4.whenYouApply') }}</li>
        <li>{{ $t('paypal.modalPayLater.aboutPayIn4.weDontCharge') }}</li>
        <li>
          {{ $t('paypal.modalPayLater.aboutPayIn4.youMustLive') }}
        </li>
      </ul>
    </div>

    <div v-if="isCountryGreatBritain" class="paypal-pay-later-info__details-info details-info">
      <i18n
        path="paypal.modalPayLater.paypalInfoBritain"
        tag="p"
        class="details-info__general-info u-typography-helvetica u-text u-text--xs"
      >
        <a
          href="https://www.paypal.com/uk/webapps/mpp/paypal-payin3/faq"
          target="__blank"
          rel="noopener"
          class="details-info__link u-typography-helvetica u-text u-text--xs"
        >
          {{ $t('paypal.modalPayLater.label.here') }}
        </a>
      </i18n>
    </div>

    <div v-if="isCountryFrance" class="paypal-pay-later-info__details-info details-info">
      <h5 class="details-info__title u-typography-helvetica u-text u-text--s">
        {{ $t('paypal.modalPayLater.aboutPayIn4.title') }}
      </h5>
      <ul class="details-info__list u-typography-helvetica u-text u-text--xs">
        <li>{{ $t('paypal.modalPayLater.aboutPayIn4.onlyForIndividuals') }}</li>
        <li>{{ $t('paypal.modalPayLater.aboutPayIn4.frenchAccountRequired') }}</li>
        <li>{{ $t('paypal.modalPayLater.aboutPayIn4.payIn4Available') }}</li>
      </ul>
      <p class="details-info__paragraph u-typography-helvetica u-text u-text--xs">
        {{ $t('paypal.modalPayLater.aboutPayIn4.loanIsABinding') }}
      </p>
      <i18n
        path="paypal.modalPayLater.aboutPayIn4.seeTheTerms"
        tag="p"
        class="details-info__general-info u-typography-helvetica u-text u-text--xs"
      >
        <a
          href="https://www.paypal.com/fr/webapps/mpp/ua/pay-in-4x-full"
          target="__blank"
          rel="noopener"
          class="details-info__link u-typography-helvetica u-text u-text--xs"
        >
          {{ $t('paypal.modalPayLater.aboutPayIn4.label.TermsAndConditions') }}
        </a>
      </i18n>
      <p class="details-info__general-info u-typography-helvetica u-text u-text--xs">
        {{ $t('paypal.modalPayLater.paypalInfoFrance') }}
      </p>
    </div>

    <div v-if="isCountryUSA" class="paypal-pay-later-info__details-info details-info">
      <h5 class="details-info__title u-typography-helvetica u-text u-text--s">
        {{ $t('paypal.modalPayLater.aboutPayIn4.title') }}
      </h5>
      <ul class="details-info__list u-typography-helvetica u-text u-text--xs">
        <li>{{ $t('paypal.modalPayLater.aboutPayIn4.availableToConsumers') }}</li>
        <li>{{ $t('paypal.modalPayLater.aboutPayIn4.notAvailableToResidents') }}</li>
        <li>{{ $t('paypal.modalPayLater.aboutPayIn4.lateFees') }}</li>
        <li>{{ $t('paypal.modalPayLater.aboutPayIn4.softCreditCheck') }}</li>
        <li>{{ $t('paypal.modalPayLater.aboutPayIn4.legalAge') }}</li>
        <li>{{ $t('paypal.modalPayLater.aboutPayIn4.loansToCalifornia') }}</li>
        <li>{{ $t('paypal.modalPayLater.paypalInfoUSA') }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { COUNTRY_ISO } from '@/constants/countries';

const PAYPAL_CONFIG = {
  [COUNTRY_ISO.AUSTRALIA]: {
    home: {
      title: 'paypal.modalPayLater.title.payIn4',
      mainDescription: 'paypal.modalPayLater.descriptionMainAustralia.cart',
      secondaryDescription: 'paypal.modalPayLater.descriptionSecondaryAustralia',
      paypalPayLaterLabel: 'paypal.modalPayLater.label.payIn4'
    },
    cart: {
      title: 'paypal.modalPayLater.title.payIn4',
      mainDescription: 'paypal.modalPayLater.descriptionMainAustralia.cart',
      secondaryDescription: 'paypal.modalPayLater.descriptionSecondaryAustralia',
      paypalPayLaterLabel: 'paypal.modalPayLater.label.payIn4'
    },
    payment: {
      title: 'paypal.modalPayLater.title.payIn4',
      mainDescription: 'paypal.modalPayLater.descriptionMainAustralia.checkout',
      secondaryDescription: 'paypal.modalPayLater.descriptionSecondaryAustralia',
      paypalPayLaterLabel: 'paypal.modalPayLater.label.payIn4'
    }
  },
  [COUNTRY_ISO.FRANCE]: {
    home: {
      title: 'paypal.modalPayLater.title.payIn4',
      mainDescription: 'paypal.modalPayLater.descriptionMainFrance.cart',
      secondaryDescription: 'paypal.modalPayLater.descriptionSecondaryFrance',
      paypalPayLaterLabel: 'paypal.modalPayLater.label.payIn4'
    },
    cart: {
      title: 'paypal.modalPayLater.title.payIn4',
      mainDescription: 'paypal.modalPayLater.descriptionMainFrance.cart',
      secondaryDescription: 'paypal.modalPayLater.descriptionSecondaryFrance',
      paypalPayLaterLabel: 'paypal.modalPayLater.label.payIn4'
    },
    payment: {
      title: 'paypal.modalPayLater.title.payIn4',
      mainDescription: 'paypal.modalPayLater.descriptionMainFrance.checkout',
      secondaryDescription: 'paypal.modalPayLater.descriptionSecondaryFrance',
      paypalPayLaterLabel: 'paypal.modalPayLater.label.payIn4'
    }
  },
  [COUNTRY_ISO.GREAT_BRITAIN]: {
    home: {
      title: 'paypal.modalPayLater.title.payIn3',
      mainDescription: 'paypal.modalPayLater.descriptionMainBritain.cart',
      secondaryDescription: 'paypal.modalPayLater.descriptionSecondaryBritain',
      paypalPayLaterLabel: 'paypal.modalPayLater.label.payIn3'
    },
    cart: {
      title: 'paypal.modalPayLater.title.payIn3',
      mainDescription: 'paypal.modalPayLater.descriptionMainBritain.cart',
      secondaryDescription: 'paypal.modalPayLater.descriptionSecondaryBritain',
      paypalPayLaterLabel: 'paypal.modalPayLater.label.payIn3'
    },
    payment: {
      title: 'paypal.modalPayLater.title.payIn3',
      mainDescription: 'paypal.modalPayLater.descriptionMainBritain.checkout',
      secondaryDescription: 'paypal.modalPayLater.descriptionSecondaryBritain',
      paypalPayLaterLabel: 'paypal.modalPayLater.label.payIn3'
    }
  },
  [COUNTRY_ISO.UNITED_STATES]: {
    home: {
      title: 'paypal.modalPayLater.title.payIn4',
      mainDescription: 'paypal.modalPayLater.descriptionMainUSA.cart',
      secondaryDescription: 'paypal.modalPayLater.descriptionSecondaryUSA',
      paypalPayLaterLabel: 'paypal.label.payLater'
    },
    cart: {
      title: 'paypal.modalPayLater.title.payIn4',
      mainDescription: 'paypal.modalPayLater.descriptionMainUSA.cart',
      secondaryDescription: 'paypal.modalPayLater.descriptionSecondaryUSA',
      paypalPayLaterLabel: 'paypal.label.payLater'
    },
    payment: {
      title: 'paypal.modalPayLater.title.payIn4',
      mainDescription: 'paypal.modalPayLater.descriptionMainUSA.checkout',
      secondaryDescription: 'paypal.modalPayLater.descriptionSecondaryUSA',
      paypalPayLaterLabel: 'paypal.label.payLater'
    }
  }
};
export default {
  name: 'PayPalPayLaterInfo',
  props: {
    country: {
      type: String,
      default: ''
    },
    paymentAmount: {
      type: String,
      default: ''
    },
    paymentPart: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: ''
    }
  },
  computed: {
    countryValue() {
      return this.country.toUpperCase();
    },
    isCountryAustralia() {
      return this.countryValue === COUNTRY_ISO.AUSTRALIA;
    },
    isCountryFrance() {
      return this.countryValue === COUNTRY_ISO.FRANCE;
    },
    isCountryGreatBritain() {
      return this.countryValue === COUNTRY_ISO.GREAT_BRITAIN;
    },
    isCountryUSA() {
      return this.countryValue === COUNTRY_ISO.UNITED_STATES;
    },
    payLaterOptionInfo() {
      return PAYPAL_CONFIG[this.countryValue][this.placement];
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/colors.scss';

.paypal-pay-later-info {
  &__title {
    margin-bottom: 16px;
    color: $tuatara-color;
    font-weight: bold;
  }

  &__description-main {
    margin-bottom: 32px;
    color: var(--u-color-grey-900);
    font-weight: bold;
  }

  &__description-secondary {
    margin-bottom: 16px;
    color: var(--u-color-grey-400);

    &--bold-part {
      color: var(--u-color-grey-900);
      font-weight: bold;
    }
  }
}

.details-info {
  list-style-type: disc;
  padding-top: 16px;
  border-top: 1px dashed var(--u-color-grey-300);

  &__title {
    margin-bottom: 16px;
    color: var(--u-color-grey-900);
    font-weight: bold;
  }

  &__list {
    margin-left: 20px;
    color: var(--u-color-grey-500);
  }

  &__paragraph {
    margin: 20px 0;
    color: var(--u-color-grey-700);
    font-weight: bold;
  }

  &__general-info {
    color: var(--u-color-grey-400);
    margin-bottom: 20px;
  }

  &__link {
    color: #0f76a2d0;
    font-weight: bold;
    text-decoration: none;
  }
}
</style>
